import { Pipe, PipeTransform } from '@angular/core';
import { ProgramStudiowStudentaStatus } from '@interfaces/stypendia/program-studiow-studenta-status.enum';

@Pipe({
  name: 'statusStudenta',
})
export class StatusStudentaPipe implements PipeTransform {
  transform(value: ProgramStudiowStudentaStatus): string {
    switch (value) {
      case ProgramStudiowStudentaStatus.Student:
        return 'bg-primary-500 text-white';
      case ProgramStudiowStudentaStatus.Skreslony:
        return 'bg-danger';
    }
  }
}
